export default __webpack_public_path__ + "static/media/calendar.7354ca32.svg";